import { NgModule } from '@angular/core';
import { GoogleAnalyticsComponent } from './google-analytics.component';
import { AngularUpgradeHelper } from '@caslink/common-client/ng-app/helpers/AngularUpgradeHelper';

@NgModule({
    declarations: [
        GoogleAnalyticsComponent
    ],
    exports: [
        GoogleAnalyticsComponent
    ],
    entryComponents: [
        GoogleAnalyticsComponent
    ]
})
export class GoogleAnalyticsModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            GoogleAnalyticsComponent
        ]);
    }
}
